export default __webpack_public_path__ + "static/media/dropdown-triangle-up.8c03bdaf.svg";